import React from 'react';
import axios from 'axios';
import store from 'store2';

import { connect } from 'react-redux';

import ProductCounter from './ProductCounter';
import StoreAdapter from './StoreAdapter';

class DecrementItem extends StoreAdapter {

    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            apiId: props.apiId,
            test: props.test,
            typingTimeout: 0,
            value: null,
        };
        this.timer = null;
        this.quantityAction = this.quantityAction.bind(this);
        this.cancelableAction = this.cancelableAction.bind(this);
    }


    mapStateToProps = (state) => {
        var product = state[this.state.test]
        return {
            article: product
        }
    };
    //ANzahl wird im kästchen nur durch enter taste neu geladen, muss verbessert
    article = (props) => {
        return (
            <React.Fragment>
                <button type="button" className="decrementBtn" onClick={(e) => this.quantityAction(props.article.quantity-1, props.article.id)}/>
                <ProductCounter test={this.state.test}/>
                <button type="button" className="incrementBtn" onClick={(e) => this.quantityAction(props.article.quantity+1, props.article.id)}/>
            </React.Fragment>
        );
    }

    cancelableAction = (value, id) => {
        clearTimeout(this.state.typingTimeout);
        setTimeout(() => {this.quantityAction(value, id);}, 1000);
    }

    quantityAction = async (quantity, id) =>{
        if(quantity === 0){
            this.setProductFading(this.state.test);
        }
        await axios.post('/api/shopingo/cart/item/update',
        JSON.stringify({
            quantity: quantity, 
            id: id
        }));

        store.session(false);
        this.refreshStore('cartlist');
        this.refreshStore('cart');
    }

    connectedProduct = connect(this.mapStateToProps)(this.article);
    render() {
        return (
           <this.connectedProduct/>
        );
    }
}

export default DecrementItem;